import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {ListElementComponent} from '../../../../craft/list-element/list-element.component'
import {ContentSectionComponent} from '../../../../craft/content-section/content-section.component'

export interface RelatedItem {
  id: string
  name: string
  link: string
}

@Component({
  selector: 'bgo-related-items-section',
  templateUrl: './related-items-section.component.html',
  styles: `
    @reference '../../../../../styles/theme.css';

    :host {
      @apply block;
      @apply last:!mb-3xl;
    }
  `,
  host: {'[class.h-content-layout]': 'true'},
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ListElementComponent, ContentSectionComponent],
})
export class RelatedItemsSectionComponent {
  title = input<string>()
  relatedItems = input<RelatedItem[]>()
}
